import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { ChartPeriod, TradePricesChartData } from "../types";
import { loadGraphDataHistorical } from "../thunks/loadGraphDataH";

export const useGraphDataH = (graphId: string) => {
	const dispatch = useDispatch();
	const period = useSelector<StoreType, ChartPeriod>(s => s.data.trading.ticker.graphPeriodH[graphId]);
	const prodId = useSelector<StoreType, string | undefined>(s => s.ux.trading.ticker.graphProductId[graphId]);
	const data = useSelector<StoreType, TradePricesChartData[] | undefined>(
		s => s.data.trading.ticker.graphData[graphId || ""]
	);

	React.useEffect(() => {
		if (prodId) {
			dispatch(loadGraphDataHistorical(graphId, prodId, period || ChartPeriod.Month));
		}
	}, [graphId, period, prodId, dispatch]);

	return [data];
};
